import React from "react"

import HotTable from "../utils/hot-table";

export default class PPIInvestments extends React.Component {

	render() {

		return (
			<div className="investments-container">
				<div className="investments-title">
					Investissements
					{ this.props.consulted ? null :<div className="actions">
						<button className="button is-primary" onClick={this._handleClick.bind(this)} title="Ajouter une thématique"><i className="fa fa-plus" /></button>
					</div> }
				</div>
				<HotTable
					ref="table"
					root="investment_themes"
					headers={false}
					data={this.props.data}
					ppi={this.props.ppi}
					tableDefinition={this.props.tableDefinition}
					onCustomAction={this.props.onCustomAction}
					onToggleProject={this.props.onProjectToggle}
					onChange={this.props.onChange}
					previousYear={this.props.previousYear}
					currentUserType = {this.props.currentUserType}
				/>
			</div>
		)
	}

	_handleClick(e) {
		this.props.onCustomAction("new_investment_theme")
	}
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/table-component.js